// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/earnings",
  ListShort: "pyr/earnings/short",
  Create: "/pyr/earnings",
  Update: "/pyr/earnings",
};
